import { Component, OnInit } from '@angular/core';

import { isNullOrUndefined } from 'util';
import { isNull } from '@angular/compiler/src/output/output_ast';
import { Observable } from 'rxjs';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { DataSharingService } from '../../../auth/data-sharing.service';
import { EnlistmentService } from 'src/app/services/enlistment/enlistment.service';
import { Prevendor } from 'src/app/model/prevendor.model';

import { NgForm } from '@angular/forms';
import { ElementRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { HttpErrorResponse } from '@angular/common/http';
import { distinctUntilChanged } from 'rxjs/operators';
import { Binary } from '@angular/compiler';
import { ReplaySubject } from 'rxjs';
import { Searchgeneral } from 'src/app/model/searchgeneral.model';
import { RoleService } from 'src/app/services/role/role.service';
import { UserService } from 'src/app/services/user/user.service';
import { ToastrService } from 'ngx-toastr';
import { EvaluationService } from 'src/app/services/evaluation/evaluation.service';

@Component({
  selector: 'app-smgmaster',
  templateUrl: './smgmaster.component.html',
  styleUrls: ['./smgmaster.component.css']
})
export class SmgmasterComponent implements OnInit {

  projectID: string;
  searchGeneral: Searchgeneral;
  isListLoading: boolean = false;
  evaluationDataAny: any;
  data: any;
  projectDetails: any;
  rowData: any;
  isListLoadingForGrid: boolean = false;
  archiveClientSurveyID: string;
  domlayout: string;
  exportBool: boolean = false;
  pagination = true;
  paginationPageSize = 10;
  private gridApi;
  private gridColumnApi;
  columnDefs = [
    { headerName: '', field: '', width: 50, headerCheckboxSelection: true, checkboxSelection: true, minWidth: 40 },
    { headerName: "#", field: "index", valueGetter: "node.rowIndex + 1", minWidth: 40 },
    { headerName: "Project Id", field: "pid", filter: true, sortable: true, resizable: true },
    { headerName: "Survey Name", field: "sname", filter: true, sortable: true, resizable: true },
    { headerName: "Client Name", field: "cname", filter: true, sortable: true, resizable: true },
    { headerName: "Assigned Vendor", field: "clip", filter: true, sortable: true, resizable: true },
    { headerName: "Original Respondent ID", field: "reNo", filter: true, sortable: true, resizable: true },
    { headerName: "Encrypted Respondent ID", field: "revisedRENo", filter: true, sortable: true, resizable: true },
    { headerName: "Survey Length (in Seconds)", field: "surveyLength", filter: true, sortable: true, resizable: true },
    { headerName: "Registered IP - At Start", field: "startIP", filter: true, sortable: true, resizable: true },
    { headerName: "Registered IP - At Ends", field: "endIP", filter: true, sortable: true, resizable: true },
    { headerName: "Survey Begins At", field: "hitOnSurveyLink", filter: true, sortable: true, resizable: true },
    { headerName: "Survey Ended On", field: "hitOnStatusLink", filter: true, sortable: true, resizable: true },
    { headerName: "Machine ID", field: "fingurPrint", filter: true, sortable: true, resizable: true },
    { headerName: "Country", field: "countryName", filter: true, sortable: true, resizable: true },
    { headerName: "Latitude", field: "lat", filter: true, sortable: true, resizable: true },
    { headerName: "Longitude", field: "lon", filter: true, sortable: true, resizable: true },
    { headerName: "Survey Mode", field: "projectMode", filter: true, sortable: true, resizable: true },
    { headerName: "Respodent Status", field: "status", filter: true, sortable: true, resizable: true },
    { headerName: "Reasons", field: "reasons", filter: true, sortable: true, resizable: true },
    { headerName: "Sentry Status", field: "sentryStatus", filter: true, sortable: true, resizable: true },
  ];
  autoGroupColumnDef = {
    headerName: 'Select',
    field: 'select',
    minWidth: 250,
    cellRenderer: 'agGroupCellRenderer',
    cellRendererParams: { checkbox: true },
  };
  defaultColDef = {
    flex: 1,
    minWidth: 100,
  };
  rowSelection = 'multiple';

  constructor(public router: Router, private evaluationService: EvaluationService, private toastr: ToastrService, private roleservice: RoleService, private userService: UserService, private route: ActivatedRoute, private dataSharingService: DataSharingService,
    private enlistServices: EnlistmentService) { }

  ngOnInit() {
    this.searchGeneral = new Searchgeneral();
    this.evaluationService.getAllVendorsForEvaluation().subscribe(
      (data) => {
        this.evaluationDataAny = data;
        console.log(this.evaluationDataAny);
      }
    )
    this.domlayout = 'autoHeight';
    this.gridApi.setDomLayout('autoHeight');
    //document.querySelector('#myGrid').style.height = '';
  }

  SubmitSearchListForm(form: NgForm) {
    debugger;
    this.isListLoading = true;
    this.roleservice.SearchProjectDetails(this.searchGeneral).subscribe(
      (data: any) => {
        this.projectDetails = data;
      }
    )
    this.roleservice.SearchRespondentData(this.searchGeneral).subscribe(
      (data: any) => {
        this.isListLoading = false;
        this.isListLoadingForGrid = true;
        this.data = data;
        console.log(this.data);
        for (var item of this.data) {
          item.pid = this.projectDetails[0].projectID;
          item.cname = this.projectDetails[0].clientName;
          item.sname = this.projectDetails[0].projectName;
          var status = (item.status == 1) ? "Completed" : (item.status == 2) ? "Quota Full" : (item.status == 3) ? "Terminated" : (item.status == 4) ? "QC Rejected" : "In Progress";
          item.status = status;

          // if(item && item.hitOnStatusLink){
          //   var timeDiff = (item.hitOnSurveyLink - item.hitOnStatusLink) / 1000;
          //   item.surveyLength = timeDiff;
          // }
          // else {
          //   item.surveyLength = 0;
          // }

          if (item && item.hitOnStatusLink && item.hitOnSurveyLink) {
            var hitOnStatusLink = new Date(item.hitOnStatusLink);
            var hitOnSurveyLink = new Date(item.hitOnSurveyLink);
            var diff = hitOnStatusLink.getTime() - hitOnSurveyLink.getTime();
            var days = Math.floor(diff / (60 * 60 * 24 * 1000));
            var hours = Math.floor(diff / (60 * 60 * 1000)) - (days * 24);
            var minutes = Math.floor(diff / (60 * 1000)) - ((days * 24 * 60) + (hours * 60));
            var seconds = Math.floor(diff / 1000) - ((days * 24 * 60 * 60) + (hours * 60 * 60) + (minutes * 60));
            item.surveyLength = (days * 24 * 60 * 60) + (hours * 60 * 60) + (minutes * 60) + seconds;
          }
          else {
            item.surveyLength = 0;
          }
        }

        this.rowData = this.data;
        // debugger;
        // for (var i = 0; i < this.rowData.length; i++) {
        //   if (this.rowData[i].hitOnStatusLink)// != null || this.rowData[i].hitOnStatusLink != "")
        //   {
        //     var hitOnStatusLink = new Date(this.rowData[i].hitOnStatusLink);
        //     var hitOnSurveyLink = new Date(this.rowData[i].hitOnSurveyLink);
        //     var diff = hitOnStatusLink.getTime() - hitOnSurveyLink.getTime();
        //     var days = Math.floor(diff / (60 * 60 * 24 * 1000));
        //     var hours = Math.floor(diff / (60 * 60 * 1000)) - (days * 24);
        //     var minutes = Math.floor(diff / (60 * 1000)) - ((days * 24 * 60) + (hours * 60));
        //     var seconds = Math.floor(diff / 1000) - ((days * 24 * 60 * 60) + (hours * 60 * 60) + (minutes * 60));
        //     this.rowData[i].surveyLength = (days * 24 * 60 * 60) + (hours * 60 * 60) + (minutes * 60) + seconds;
        //   }
        // }

        if (this.data.length == 0) {
          this.exportBool = false;
          this.isListLoadingForGrid = false;
          this.toastr.error("No items found", '', { progressBar: true });
        }
        else {
          this.exportBool = true;
        }

        // this.allRows = this.data.length;
      }
    )
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  downloadExcel() {
    var params = {
      processCellCallback: (params) => {

        if(params.column.getColId() === 'hitOnSurveyLink' || 
          params.column.getColId() === 'hitOnStatusLink') {

          if(params.value){
            const date = new Date(params.value);

            return date.toLocaleString('en-US', {
              year: 'numeric',
              month: '2-digit',
              day: '2-digit',
              hour: '2-digit',
              minute: '2-digit',
              second: '2-digit',
              hour12: true   // ⭐ THIS ADDS AM/PM
            });
          }
        }

        return params.value;
      }
    };

    this.gridApi.exportDataAsCsv(params);
  }

  archiveSelected() {
    debugger;
    let selectedNodes = this.gridApi.getSelectedNodes();
    this.archiveClientSurveyID = "";
    for (let item of selectedNodes) {
      this.archiveClientSurveyID += item.data.clientSurveyID + ",";
    }
    if (selectedNodes.length > 0) {
      this.archiveClientSurveyID = this.archiveClientSurveyID.substring(0, this.archiveClientSurveyID.length - 1);
      console.log(this.archiveClientSurveyID);
      this.archiveClientSurveyData(this.archiveClientSurveyID);
    }
    else {
      this.toastr.warning("Select atleast one CheckBox", '', { progressBar: true });
    }
  }

  archiveClientSurveyData(archiveClientSurveyID) {
    debugger;
    this.userService.deleteClientSurveyData(archiveClientSurveyID).subscribe(
      (data) => {
        if (data == true) {
          this.fetchData("Archieve");
        }
        else {

        }
      }
    )
  }

  changeToComplete() {
    debugger;
    let selectedNodes = this.gridApi.getSelectedNodes();
    this.archiveClientSurveyID = "";
    for (let item of selectedNodes) {
      this.archiveClientSurveyID += item.data.clientSurveyID + ",";
    }
    if (selectedNodes.length > 0) {
      this.archiveClientSurveyID = this.archiveClientSurveyID.substring(0, this.archiveClientSurveyID.length - 1);
      this.dataChangeToComplete(this.archiveClientSurveyID);
    }
    else {
      this.toastr.warning("Select atleast one CheckBox", '', { progressBar: true });
    }
  }

  dataChangeToComplete(archiveClientSurveyID) {
    debugger;
    this.userService.changeDataToComplete(archiveClientSurveyID).subscribe(
      (data) => {
        if (data == true) {
          this.fetchData("StatusChange");
        }
        else {

        }
      }
    )
  }

  changeToQuotaFull() {
    debugger;
    let selectedNodes = this.gridApi.getSelectedNodes();
    this.archiveClientSurveyID = "";
    for (let item of selectedNodes) {
      this.archiveClientSurveyID += item.data.clientSurveyID + ",";
    }
    if (selectedNodes.length > 0) {
      this.archiveClientSurveyID = this.archiveClientSurveyID.substring(0, this.archiveClientSurveyID.length - 1);
      console.log(this.archiveClientSurveyID);
      this.dataChangeToQuotaFull(this.archiveClientSurveyID);
    }
    else {
      this.toastr.warning("Select atleast one CheckBox", '', { progressBar: true });
    }
  }

  dataChangeToQuotaFull(archiveClientSurveyID) {
    debugger;
    this.userService.changeDataToQuotaFull(archiveClientSurveyID).subscribe(
      (data) => {
        if (data == true) {
          this.fetchData("StatusChange");
        }
        else {

        }
      }
    )
  }
  changeToTerminated() {
    debugger;
    let selectedNodes = this.gridApi.getSelectedNodes();
    this.archiveClientSurveyID = "";
    for (let item of selectedNodes) {
      this.archiveClientSurveyID += item.data.clientSurveyID + ",";
    }
    if (selectedNodes.length > 0) {
      this.archiveClientSurveyID = this.archiveClientSurveyID.substring(0, this.archiveClientSurveyID.length - 1);
      console.log(this.archiveClientSurveyID);
      this.dataChangeToTerminated(this.archiveClientSurveyID);
    }
    else {
      this.toastr.warning("Select atleast one CheckBox", '', { progressBar: true });
    }
  }

  dataChangeToTerminated(archiveClientSurveyID) {
    debugger;
    this.userService.changeDataToTerminated(archiveClientSurveyID).subscribe(
      (data) => {
        if (data == true) {
          this.fetchData("StatusChange");
        }
        else {

        }
      }
    )
  }
  changeToQCRejected() {
    debugger;
    let selectedNodes = this.gridApi.getSelectedNodes();
    this.archiveClientSurveyID = "";
    for (let item of selectedNodes) {
      this.archiveClientSurveyID += item.data.clientSurveyID + ",";
    }
    if (selectedNodes.length > 0) {
      this.archiveClientSurveyID = this.archiveClientSurveyID.substring(0, this.archiveClientSurveyID.length - 1);
      console.log(this.archiveClientSurveyID);
      this.dataChangeToQCRejected(this.archiveClientSurveyID);
    }
    else {
      this.toastr.warning("Select atleast one CheckBox", '', { progressBar: true });
    }
  }

  dataChangeToQCRejected(archiveClientSurveyID) {
    debugger;
    this.userService.changeDataToQCRejected(archiveClientSurveyID).subscribe(
      (data) => {
        if (data == true) {
          this.fetchData("StatusChange");
        }
        else {

        }
      }
    )
  }

  changeToInProgress() {
    debugger;
    let selectedNodes = this.gridApi.getSelectedNodes();
    this.archiveClientSurveyID = "";
    for (let item of selectedNodes) {
      this.archiveClientSurveyID += item.data.clientSurveyID + ",";
    }
    if (selectedNodes.length > 0) {
      this.archiveClientSurveyID = this.archiveClientSurveyID.substring(0, this.archiveClientSurveyID.length - 1);
      console.log(this.archiveClientSurveyID);
      this.dataChangeToInProgress(this.archiveClientSurveyID);
    }
    else {
      this.toastr.warning("Select atleast one CheckBox", '', { progressBar: true });
    }
  }

  dataChangeToInProgress(archiveClientSurveyID) {
    debugger;
    this.userService.changeDataToInProgress(archiveClientSurveyID).subscribe(
      (data) => {
        if (data == true) {
          this.fetchData("StatusChange");
        }
        else {

        }
      }
    )
  }

  fetchData(isStatusChange = "") {
    this.roleservice.SearchRespondentData(this.searchGeneral).subscribe(
      (data: any) => {
        this.data = data;
        debugger;
        for (var item of this.data) {
          item.pid = this.projectDetails[0].projectID;
          item.cname = this.projectDetails[0].clientName;
          item.sname = this.projectDetails[0].projectName;
          var status = (item.status == 1) ? "Completed" : (item.status == 2) ? "Quota Full" : (item.status == 3) ? "Terminated" : (item.status == 4) ? "QC Rejected" : "In Progress";
          item.status = status;
        }
        this.rowData = this.data;
        for (var i = 0; i < this.rowData.length; i++) {
          if (this.rowData[i].hitOnStatusLink)// != null || this.rowData[i].hitOnStatusLink != "")
          {
            var hitOnStatusLink = new Date(this.rowData[i].hitOnStatusLink);
            var hitOnSurveyLink = new Date(this.rowData[i].hitOnSurveyLink);
            var diff = hitOnStatusLink.getTime() - hitOnSurveyLink.getTime();
            var days = Math.floor(diff / (60 * 60 * 24 * 1000));
            var hours = Math.floor(diff / (60 * 60 * 1000)) - (days * 24);
            var minutes = Math.floor(diff / (60 * 1000)) - ((days * 24 * 60) + (hours * 60));
            var seconds = Math.floor(diff / 1000) - ((days * 24 * 60 * 60) + (hours * 60 * 60) + (minutes * 60));
            this.rowData[i].surveyLength = seconds;
          }
        }
        if (isStatusChange == "StatusChange") {
          this.toastr.success("Status Changed", '', { progressBar: true });
        }
        else if (isStatusChange == "IPReset") {
          this.toastr.success("IP Reset", '', { progressBar: true });
        }
        else if (isStatusChange == "Archieve") {
          this.toastr.success("Survey Deleted Successfully", '', { progressBar: true });
        }
      }
    )
  }

  MoveData() {
    debugger;
    let selectedNodes = this.gridApi.getSelectedNodes();
    this.archiveClientSurveyID = "";
    for (let item of selectedNodes) {
      this.archiveClientSurveyID += item.data.clientSurveyID + ",";
    }
    if (selectedNodes.length > 0) {
      $("#Modal").css("width", "77%");
      $("#myModal").show();
    }
    else {
      this.toastr.warning("Select atleast one CheckBox", '', { progressBar: true });
    }
  }

  closeDialog() {
    $("#myModal").hide();
  }

  moveClick(id) {
    debugger;
    console.log(id);
    if (id == undefined) {
      this.toastr.error("Select Project Id", '', { progressBar: true });
    }
    else {
      let selectedNodes = this.gridApi.getSelectedNodes();
      this.archiveClientSurveyID = "";
      for (let item of selectedNodes) {
        this.archiveClientSurveyID += item.data.clientSurveyID + ",";
      }
      this.archiveClientSurveyID = this.archiveClientSurveyID.substring(0, this.archiveClientSurveyID.length - 1);
      this.userService.MoveDataToId(this.archiveClientSurveyID, id).subscribe(
        (data) => {
          if (data) {
            this.toastr.success("Moved Successfully", '', { progressBar: true });
            this.projectID = "";
            $("#myModal").hide();
            this.gridApi.deselectAll();
          }
          else {
            this.toastr.error("Some Error Occur", '', { progressBar: true });
          }
        }
      )
    }
  }

  ResetIP() {
    let selectedNodes = this.gridApi.getSelectedNodes();
    this.archiveClientSurveyID = "";
    for (let item of selectedNodes) {
      this.archiveClientSurveyID += item.data.clientSurveyID + ",";
    }
    if (selectedNodes.length > 0) {
      this.archiveClientSurveyID = this.archiveClientSurveyID.substring(0, this.archiveClientSurveyID.length - 1);
      this.userService.resetip(this.archiveClientSurveyID).subscribe(
        (data) => {
          if (data == true) {
            this.fetchData("IPReset");
          }
          else {

          }
        }
      )
    }
    else {
      this.toastr.warning("Select atleast one CheckBox", '', { progressBar: true });
    }
  }

  parseDate(input) {
    var parts = input.match(/(\d+)/g);
    // new Date(year, month [, date [, hours[, minutes[, seconds[, ms]]]]])
    return new Date(parts[0], parts[1] - 1, parts[2]); // months are 0-based
  }
}
